<template>
    <div id="vue-social">
        <div class="post__interactions" :data-did="dId">
            <div class="card-message right" :class="{ show: showMessage }" :style="{ bottom: 'auto', top: msgY }">
                <img :src="$cdn('/img/ui/cancel.svg')" alt="close" @click="close">
                <div>
                    <h5>{{ message.title }}</h5>
                </div>
                <p v-html="message.content"></p>
                <p v-if="message.showLink">
                    <a @click="like(true)">{{ message.linkText }}</a>
                </p>
            </div>
            <div class="post__likes" @click="like(false)" :class="{ liked: postLiked }">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 21" fill="none">
                    <path d="M11.728 19.8376C11.29 19.5766 1 13.3538 1 6.76474C1 3.58612 3.62739 1 6.85673 1C9.02896 1 10.9907 2.18834 12 4.00725C13.0093 2.18834 14.971 1 17.1433 1C20.3726 1 23 3.58612 23 6.76474C23 13.3538 12.71 19.5755 12.272 19.8376L12 20L11.728 19.8376Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>{{ postLikes }}</span>
            </div>
            <div
                class="post__comments"
                @click="comment"
                :class="{ commented: commented }"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
                    <path d="M21 20L19.4891 14.4021C20.4468 12.339 20.6181 10.0081 19.9719 7.83187C19.3256 5.65568 17.9047 3.77825 15.9665 2.53997C14.0284 1.30168 11.7014 0.784484 9.40743 1.08212C7.11341 1.37975 5.00419 2.47254 3.46214 4.16235C1.92008 5.85216 1.04725 8.02716 1.00186 10.2931C0.956479 12.559 1.74155 14.7659 3.21475 16.5136C4.68796 18.2614 6.7518 19.4343 9.03214 19.8198C11.3125 20.2053 13.6584 19.7779 15.6446 18.615L21 20Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>{{ commentsCount }}</span>
            </div>
            <div v-if="showReposts" class="post__repost" @click="repost" :class="{ reposted: hasReposted }">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                    <path d="M1 4V6C1 9.31371 3.68629 12 7 12H11M21 12V10C21 6.68629 18.3137 4 15 4H11" stroke="black" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M14 1L11 4L14 7" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M9 15L12 12L9 9" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>{{ reposts > 0 ? reposts : '' }}</span>
            </div>
            <div class="post__share">
                <a href="#" @click.prevent="shareButtons">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                        <path d="M1 9V18C1 19.1046 1.89543 20 3 20H18C19.1046 20 20 19.1046 20 18V9" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M11 14.7748V2.4248" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.25 5.75L11 1L15.75 5.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </a>
            </div>
        </div>
        <div v-if="reposts > 0" class="post__reposts u-cursor-pointer" @click.prevent="openRepostedModal">
            <div class="post__reposted">
                <span v-if="reposts === 1">Reposted in {{ reposts }} community</span>
                <span v-else>Reposted in {{ reposts }} communities</span>
                <div v-if="repostedCommunities.length > 0" class="post__reposted-communities">
                    <div
                        v-for="(community, index) in repostedCommunities.slice(0, 3)"
                        :key="community.community_id"
                        class="post__reposted-community"
                    >
                        <img
                            :src="$simpleStore.transformImageWithCloudfront(40, 40, 'img/communities/' + community.community_id + '/' + community.image, $root)"
                            :alt="community.name"
                        >
                    </div>
                    <div v-if="reposts > 3" class="post__reposted-community post__reposted-community--more">+{{ reposts - 3 }}</div>
                </div>
            </div>
        </div>
        <Menu
            :show-menu="showRepostedModal"
            :close-event="repostedModalCloseEvent"
            :top="true"
            :scroll-class="'menu__content--scroll'"
        >
            <div>
                <div class="menu__title">
                    <p>"{{ postTitle }}" has been reposted to the following communities</p>
                </div>
                <div class="menu__items">
                    <a
                        class="items"
                        v-for="community in repostedCommunities"
                        :key="community.community_id"
                        :href="'/' + community.url + '/reposts'"
                    >
                        <img
                            :src="$simpleStore.transformImageWithCloudfront(50, 50, 'img/communities/' + community.community_id + '/' + community.image, $root)"
                            :alt="community.name"
                            width="50"
                            height="50"
                            class="u-radius-4"
                        >
                        <div class="items__details">
                            <p>{{ community.name }}
                                <span>{{ community.repost_count === 1 ? '1 repost' : community.repost_count + ' reposts' }}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </Menu>
        <ugc-reposting
            v-if="showReposts"
            ref="repostPanel"
            :standalone="true"
            :modal="true"
            :dyadey-id="dId"
            :source-community-id="$root.post ? $root.post.community_id : 0"
            :has-reposted="hasReposted"
            @repost-success="onRepostSuccess"
            @repost-removed="onRepostRemoved"
            @no-communities="onNoCommunities"
        />
    </div>
</template>

<script>
import UgcReposting from '../ugc/UgcReposting';
import Menu from '../menu/Menu';

export default {
    components: { UgcReposting, Menu },
    props: {
        showReposts: Boolean,
    },
    data() {
        return {
            dId: this.$root.dyadey_id,
            isMember: this.$root.is_member,
            msgY: "-164px",
            message: this.$simpleStore.message,
            postLiked: this.$root.liked,
            postLikes: this.$root.likes,
            commented: this.$root.commented,
            reposts: this.$root.reposts,
            hasReposted: this.$root.reposted,
            commentsCount: 0,
            stats: this.$simpleStore.stats,
            showMessage: false,
            repostedCommunities: [],
            showRepostedModal: false,
            repostedModalCloseEvent: 'bus-reposted-communities-modal-close',
            postTitle: this.$root.post?.post_page_title ?? '',
        };
    },
    created() {
        this.$root.$on("update-icon-comment-count", () => {
            this.commentsCount = 0;
        });
        this.$root.$on(this.repostedModalCloseEvent, () => {
            this.showRepostedModal = false;
        });
        if (this.reposts > 0) {
            this.fetchRepostedCommunities();
        }
    },
    methods: {
        close() {
            this.showMessage = false;
        },
        like(confirmed) {
            if (this.$root.user !== false) {
                this.$simpleStore.like(this, confirmed);
            } else {
                this.$simpleStore.showMemberPanel(this);
            }
        },
        repost() {
            if (this.$root.user === false) {
                this.$simpleStore.showMemberPanel(this);
                return;
            }
            if (!this.isMember) {
                this.message = {
                    title: 'Join this community',
                    content: 'You need to join this community before you can repost.',
                    showLink: false,
                };
                this.showMessage = true;
                return;
            }
            this.$refs.repostPanel.panelOpen();
        },
        onNoCommunities() {
            this.message = {
                title: 'No communities to repost to',
                content: 'You need to be a member of at least one other community to repost.',
                showLink: false,
            };
            this.showMessage = true;
        },
        onRepostSuccess(repostedTo) {
            this.reposts += repostedTo.length;
            this.hasReposted = true;
            this.fetchRepostedCommunities();
        },
        onRepostRemoved({ communityCount, userHasReposts }) {
            this.reposts = communityCount;
            this.hasReposted = userHasReposts;
            if (communityCount > 0) {
                this.fetchRepostedCommunities();
            } else {
                this.repostedCommunities = [];
            }
        },
        fetchRepostedCommunities() {
            this.$http.get('/api/v1/posts/reposted/' + this.dId).then(response => {
                const data = response.data;
                // API returns { communities: [...], total_reposts: N }
                this.repostedCommunities = data.communities || data;
            });
        },
        openRepostedModal() {
            if (this.repostedCommunities.length === 0) {
                this.fetchRepostedCommunities();
            }
            this.showRepostedModal = true;
        },
        comment() {},
        shareButtons() {
            this.$root.$emit('bus-index-post-menu-share');
        }
    },
};
</script>
